import React, { useEffect, useState } from 'react'
import { 
  FiAward, 
  FiPlus, 
  FiRefreshCw,
  FiSearch,
  FiFilter,
  FiGrid,
  FiList,
  FiCheckCircle,
  FiXCircle,
  FiClock,
  FiUser,
  FiBookOpen,
  FiCalendar,
  FiEye,
  FiEdit2,
  FiTrash2,
  FiDownload,
  FiFileText,
  FiUsers,
  FiStar,
  FiTrendingUp,
  FiSettings,
  FiPrinter,
  FiShare2,
  FiClipboard
} from "react-icons/fi";
import { 
  MdVerified,
  MdDownload,
  MdVisibility,
  MdEdit,
  MdDelete,
  MdCheckCircle,
  MdCancel,
  MdPending,
  MdOutlineVerified,
  MdOutlineCheckCircle,
  MdOutlinePending,
  MdOutlineCancel,
  MdGrading,
  MdAssignment,
  MdSchool,
  MdOutlineGrading
} from "react-icons/md";
import { IoDocumentTextOutline, IoTrophyOutline, IoRibbonOutline } from "react-icons/io5";
import Button from '../../components/Button/Button'
import CertificateTable from './Table/CertificateTable';
import CertificateTemplete from './Template/CertificateTemplete';
import StatusUpdateModal from './Modal/StatusUpdateModal';
import { useDispatch, useSelector } from 'react-redux'
import { getCertificateList, getCertificateStatus } from '../../Redux/certificateSlice';
import { useNavigate } from 'react-router';
import { baseURL } from '../../BaseURL';

const CertificateMangment = () => {
    const [activeTab, setActiveTab] = useState('Certificates');
    const [isMenu, setIsMenu] = useState(false)
    const [isStatusModal, setIsStatusModal] = useState(false)
    const [statusData, setStatusData] = useState({
        campaignContent: ""
    });
    const navigate = useNavigate();
    const [filter, setFilter] = useState({
        size: 10,
        pageNo: 1,
        keyWord: "",
        sortBy: "createdAt",
        sortOrder: "desc"
    })
    const dispatch = useDispatch()
    const certificateList = useSelector((state) => state.certificate.getList);

    useEffect(() => {
        dispatch(getCertificateList(filter));
    }, [dispatch, filter]);

    const [clickedUserId, setClickedUserId] = useState(null)
    const tableHeader = [
        { label: '#', sortKey: null },
        { label: 'Certificate & ID', sortKey: 'certificateId' },
        { label: 'Learner Name', sortKey: 'user.fullName' },
        { label: "Course", sortKey: 'course.title' },
        { label: 'Status', sortKey: 'status' },
        { label: 'Issue Date', sortKey: 'createdAt' }
    ];
    
    const handleSort = (key) => {
        setFilter((prev) => {
            const isSameKey = prev.sortBy === key;
            return {
                ...prev,
                sortBy: key,
                sortOrder: isSameKey && prev.sortOrder === "asc" ? "desc" : "asc",
                pageNo: 1
            };
        });
    };
    
    const showMenu = (userId) => {
        if (clickedUserId === userId) {
            setIsMenu(!isMenu);
        } else {
            setClickedUserId(userId);
            setIsMenu(true);
        }
    };
    
    const handleEditCertificate = (data) => {
        console.log(data)
    }
    
    const handleChangeStatus = (id) => {
        dispatch(getCertificateStatus({ payload: { _id: id }, filter: filter }));
    }
    
    const toggleStatusModal = () => {
        setIsStatusModal(!isStatusModal)
    }
    
    const hadnleStatusOnChange = (e) => { 
        const { name, value } = e.target; 
        setStatusData({ ...statusData, [name]: value }) 
    }

    const handlePreview = async (e) => {
        const certificateURL = e.certificateURL.split("certificates/")[1];
        const previewURL = `${baseURL}/v1/course/previewCertificate?fileName=${certificateURL}`;
        return previewURL;
    }

    // Calculate statistics
    const totalCertificates = certificateList?.list?.length || 0;
    const activeCertificates = certificateList?.list?.filter(c => c?.status === 'active')?.length || 0;
    const pendingCertificates = certificateList?.list?.filter(c => c?.status === 'pending')?.length || 0;
    const revokedCertificates = certificateList?.list?.filter(c => c?.status === 'revoked')?.length || 0;

    // Stats cards data
    const statsCards = [
        // {
        //     title: 'Total Certificates',
        //     count: totalCertificates,
        //     icon: IoRibbonOutline,
        //     color: 'from-blue-500 to-blue-600',
        //     bgColor: 'bg-blue-50',
        //     textColor: 'text-blue-600',
        //     subtitle: 'All certificates issued'
        // },
        // {
        //     title: 'Active',
        //     count: activeCertificates,
        //     icon: MdOutlineCheckCircle,
        //     color: 'from-emerald-500 to-emerald-600',
        //     bgColor: 'bg-emerald-50',
        //     textColor: 'text-emerald-600',
        //     subtitle: 'Valid certificates'
        // },
        // {
        //     title: 'Pending',
        //     count: pendingCertificates,
        //     icon: MdOutlinePending,
        //     color: 'from-amber-500 to-amber-600',
        //     bgColor: 'bg-amber-50',
        //     textColor: 'text-amber-600',
        //     subtitle: 'Awaiting review'
        // },
        // {
        //     title: 'Revoked',
        //     count: revokedCertificates,
        //     icon: MdOutlineCancel,
        //     color: 'from-rose-500 to-rose-600',
        //     bgColor: 'bg-rose-50',
        //     textColor: 'text-rose-600',
        //     subtitle: 'Revoked certificates'
        // }
    ];

    return (
        <div className="min-h-screen bg-gray-50/80">
            {/* Header Banner */}
            <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
                {/* Decorative elements */}
                <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
                <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
                <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
                
                <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                        <div className="flex items-center gap-3">
                            <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                                <IoRibbonOutline className="w-5 h-5 text-white md:w-6 md:h-6" />
                            </div>
                            <div>
                                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                                    Certification Management
                                </h2>
                                <p className="text-sm text-white/70 hidden sm:block">
                                    Manage and track certificates
                                </p>
                            </div>
                        </div>
                        {/* <div className="flex items-center gap-2">
                            <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                                <span className="text-xs text-white/80">
                                    {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                </span>
                            </div>
                        </div> */}
                    </div>

                    {/* Stats Cards */}
                    <div className="grid grid-cols-2 gap-3 mt-5 sm:grid-cols-4 md:gap-4">
                        {statsCards.map((card, index) => (
                            <div 
                                key={index}
                                className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300 group"
                            >
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-[10px] font-medium text-white/60 uppercase tracking-wider">
                                            {card.title}
                                        </p>
                                        <p className="text-xl font-bold text-white md:text-2xl mt-0.5">
                                            {card.count}
                                        </p>
                                        {card.subtitle && (
                                            <p className="text-[10px] text-white/40 hidden sm:block">
                                                {card.subtitle}
                                            </p>
                                        )}
                                    </div>
                                    <div className={`p-2 rounded-xl bg-gradient-to-br ${card.color} bg-opacity-30 shadow-inner`}>
                                        <card.icon className="w-4 h-4 text-white md:w-5 md:h-5" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
                <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
                    {/* Tab Navigation */}
                    <div className="flex flex-wrap border-b border-gray-100 bg-gray-50/50">
                        <button
                            className={`
                                flex items-center gap-2 px-4 py-3 text-sm font-medium transition-all duration-200
                                ${activeTab === "Certificates" 
                                    ? "text-[#715EFE] border-b-2 border-[#715EFE] bg-white" 
                                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                                }
                            `}
                            onClick={() => setActiveTab("Certificates")}
                        >
                            <FiAward className="w-4 h-4" />
                            <span>Certificates</span>
                            <span className="px-1.5 py-0.5 text-xs font-medium text-[#715EFE] bg-[#715EFE]/10 rounded-full">
                                {totalCertificates}
                            </span>
                        </button>
                        <button
                            className={`
                                flex items-center gap-2 px-4 py-3 text-sm font-medium transition-all duration-200
                                ${activeTab === "Certificates_Template" 
                                    ? "text-[#715EFE] border-b-2 border-[#715EFE] bg-white" 
                                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                                }
                            `}
                            onClick={() => setActiveTab("Certificates_Template")}
                        >
                            <IoDocumentTextOutline className="w-4 h-4" />
                            <span>Certificate Template</span>
                        </button>
                    </div>

                    {/* Content */}
                    <div className="p-3 md:p-4">
                        {activeTab === 'Certificates' && (
                            <CertificateTable 
                                handlePreview={handlePreview} 
                                filter={filter} 
                                setFilter={setFilter} 
                                TableName={`Certificates`} 
                                TableHeader={tableHeader} 
                                TableData={certificateList} 
                                showMenu={showMenu} 
                                clickedUserId={clickedUserId} 
                                isMenu={isMenu} 
                                editAction={handleEditCertificate} 
                                handleChangeStatus={handleChangeStatus} 
                                baseURL={baseURL} 
                                currentSortKey={filter.sortBy}
                                currentSortOrder={filter.sortOrder}
                                onSort={handleSort}
                            />
                        )}
                        {activeTab === 'Certificates_Template' && (
                            <CertificateTemplete />
                        )}
                    </div>
                </div>
            </section>

            {/* Status Update Modal */}
            {isStatusModal && (
                <StatusUpdateModal 
                    inputData={statusData} 
                    onCancel={toggleStatusModal} 
                    handleONChange={hadnleStatusOnChange} 
                />
            )}
        </div>
    )
}

export default CertificateMangment